export default __webpack_public_path__ + "static/media/TanyaFit.11382df2.jpg";